"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amountWithCurrencySchema = void 0;
const zod_1 = require("zod");
const Currency_1 = require("../../../common/Currency");
const constants_1 = require("../../../common/constants");
const transformAmountWithCurrency = (value, context) => {
    const regexFormat = new RegExp(`^-?\\d{1,${constants_1.NUMBER_MAX_LENGTH}}(?:\\.\\d{0,${constants_1.NUMBER_MAX_LENGTH}})? (${Object.values(Currency_1.Currency).join("|")})$`);
    if (!regexFormat.test(value)) {
        context.addIssue({
            message: `Invalid format for proposedTotalAmount. It should be in the format of 'number (with ${constants_1.NUMBER_MAX_LENGTH} digits max) Currency'`,
            code: zod_1.z.ZodIssueCode.custom,
        });
        return zod_1.z.NEVER;
    }
    return value;
};
exports.amountWithCurrencySchema = zod_1.z.string().transform(transformAmountWithCurrency);
//# sourceMappingURL=amountWithCurrency.schema.js.map